export default __webpack_public_path__ + "static/media/HSL_OpenMaaS_Change__cancellation_and_refund_terms_of_tickets_14.1.2021.c36f0530.pdf";